import React from 'react'

export default React.createContext<{
  isLocked: boolean
  optimisticStart?: () => void
  optimisticEnd?: () => void
  isFullyBlocked: boolean
  fullyBlockedStart?: () => void
  fullyBlockedEnd?: () => void
}>({isLocked: false, isFullyBlocked: false})
